
import Vue, { PropType } from 'vue';
import { Floor } from '@/interfaces/locations';
import { Site } from '@/interfaces/multiTenancy';
import { Room } from '@/interfaces/lighting';
import { OccupancyReport, ShortReport, RoomName } from '@/interfaces/reports';

export default Vue.extend({
	props: {
		floors: { type: Array as PropType<Floor[]> },
		selectedFloor: { type: String },
		selectedRoom: { type: Array as PropType<RoomName[]> },
		reports: { type: Object as PropType<OccupancyReport[]> },
		getRoomNames: { type: Array as PropType<Room[]> },
		selectedWeekOne: { type: Number, default: 0 },
		selectedWeekTwo: { type: Number, default: 0 },
		selectedYearOne: { type: Number, default: 0 },
		selectedYearTwo: { type: Number, default: 0 },
		results: { type: Boolean },
		selectedSite: { type: Object as PropType<Site[]> },
		getRoomZones: { type: Function },
	},
	methods: {
		getZoneNames(roomId: number): ShortReport | null {
			return this.getRoomZones(roomId).map((e: ShortReport) => {
				if (e.id === this.reports[e.id]?.fk_zone_id) {
					return {
						name: e.name,
						id: e.id,
						weekOne: this.reports[e.id]?.pct_working_h_week_one,
						weekTwo: this.reports[e.id]?.pct_working_h_week_two,
						weekOneOutside: this.reports[e.id]?.pct_outside_working_h_week_one,
						weekTwoOutside: this.reports[e.id]?.pct_outside_working_h_week_two,
						message: this.reports[e.id]?.message,
					};
				} else {
					return {
						name: '',
						id: '',
					};
				}
			});
		},
	},
});
